import BentoFeatureCard from './BentoFeatureCard';
import BentoStatCard from './BentoStatCard';
import BentoCtaCard from './BentoCtaCard';
import { BENTO_FEATURE, BENTO_STAT_CARDS } from './data';

export default function BentoSection() {
  return (
    <section id="solucoes" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mb-12 max-w-3xl">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Benefícios
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Tecnologia de incentivo para <span className="text-accent-600">vender mais.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          <article className="relative h-full min-h-[420px] overflow-hidden rounded-3xl bg-foreground-900 md:row-span-2">
            <img
              src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/09630a5aad14380163ff9fcc5b542a2d.png"
              alt="GetPoints IA com mascote robô e janela de conversa mostrando pontuação e saldo disponível para resgate em PIX"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
          </article>

          <BentoFeatureCard data={BENTO_FEATURE} />

          {BENTO_STAT_CARDS.map((stat) => (
            <BentoStatCard key={stat.value} data={stat} />
          ))}

          <BentoCtaCard />
        </div>
      </div>
    </section>
  );
}